<template>
  <el-row class="reports-box" ref="report">
    <el-col class="report-content" ref="rightRef">
      <h3>关键指标</h3>
      <div class="report-detail" :style="`height:${reportHeight - 41}px`">
        <iframe v-if="iframeSrc" :src="iframeSrc" id="bdIframe" frameborder="no" class="iframe-box scroll" scrolling="no"></iframe>
        <div class="no-result" v-else>暂无指标</div>
      </div>
    </el-col>


    <el-col class="report-list" :style="`height:${reportHeight}px`" v-loading="loading">
      <h3>应用报表</h3>
      <ul :style="`height:${reportHeight - 40 - 14}px`" v-if="list&&list.length">
        <li 
          v-for="(item, index) in list"
          :key="index"
          @click="handleActive(item)"
          v-autotip="item.name"
          >
        </li>
      </ul>
      <div class="no-result" v-else>暂无数据</div>
    </el-col>
  </el-row>
</template>

<script>
import { reportListApi, reportDetail, getDictory} from '@/util/api'
import { getToken } from "@/util/auth"
import {fetchJsonp} from '@/util/jsonp'

export default {
  data() {
    return {
      iframeSrc: '',
      list: [],
      loading: false,
      reportHeight: 0 // 报表总高度
    }
  },
  computed: {
    token() {
      return getToken().split(' ')[1] || ''
    }
  },
  mounted() {
    this.getInit()
  },
  methods: {
    async getInit() {
      this.getList()
      this.getDicData()
      this.getReportHeight()
    },
    getDicData() {
      getDictory({
        dictCode: 'FineBiConfig' // 字段标识 在技术中台配置
      }).then(res => {
        let {code, data} = res
        if(code == 0) {
          if(data && data.length) {
            let id = data[0].dataValue || ''
            this.iframeSrc = `${reportDetail}/${id}/view?access_token=${this.token}`
            this.getIframeStyle()
          }
        }
      })
    },
    getList() {
      this.loading = true
      let params = {
        op:'api',
        cmd:'get_all_reports_dat',
        access_token:  this.token
      } 
      fetchJsonp(reportListApi, params, {
        timeout: 10000
      }).then(res => {
        this.loading = false
        let {dashboards} = res.data
        this.list = dashboards
      }).catch(err => {
        this.loading = false
        console.log('--err--',err)
      })
    },
    toNewPage() {
      if(!this.iframeSrc) {
        return
      }
      window.open(this.iframeSrc)
    },
    handleActive(item) {
      let detailUrl = `${reportDetail}/${item.id}/view?access_token=${this.token}`
      window.open(detailUrl)
    },
    getIframeStyle(){
      this.$nextTick(()=>{
        if(this.iframeSrc) {
          const oIframe = document.getElementById('bdIframe')
          const deviceHeight = document.documentElement.clientHeight
          oIframe.style.height = Number(deviceHeight) + 'px'
          oIframe.style.width = '100%'
        }
      })
    },
    getReportHeight() {
      this.$nextTick(()=>{
        let height = window.innerHeight - this.$refs.report.$el.offsetTop - 20
        if(Number(height) <= 350){ //适应小屏
          this.reportHeight = 350;
        }else{
          this.reportHeight = height;
        }
      })
    }
  } 
}
</script>

<style scoped lang="less">
.reports-box{
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
  min-height: 50px;
  h3{
    font-size: 16px;
    color: @title-color;
    border-bottom: 1px solid @default-border-color;
    height: 40px;
    line-height: 40px;
    padding-left: 14px;
    font-weight: normal;
  }
  .report-list{
    background: #fff;
    border-left: 1px solid @default-border-color;
    width: 14%;
    ul{
      padding: 7px 14px;
      min-width: 155px;
      overflow: auto;
      overflow-x: hidden;
      li{
          width: calc(100% - 16px);
          display: inline-block;
          padding: 0 10px 0 8px; 
          height: 34px;
          line-height: 34px;
          color: @li-text-color;
          cursor: pointer;
          &:hover{
            background: @theme-hover-color;
            color: @theme-color;
          }
      }
    }
  }
  .report-content{
    background: #fff;
    width: calc(86% - 40px);
    margin-left: 20px;
    .report-detail{
      overflow-y: auto;
      overflow-x: hidden;
      .iframe-box{
        width: 100%;
        min-height: 100px;
      }
    }
  }
}
</style>
